import { AlertTriangle, Trash2, HelpCircle } from 'lucide-react'
import { useToast } from '../hooks/useToast'

const typeConfig = {
  danger: {
    icon: Trash2,
    iconBg: 'bg-red-100 dark:bg-red-900/30',
    iconColor: 'text-red-600 dark:text-red-400',
    confirmBtn: 'bg-red-600 hover:bg-red-700 text-white',
  },
  warning: {
    icon: AlertTriangle,
    iconBg: 'bg-yellow-100 dark:bg-yellow-900/30',
    iconColor: 'text-yellow-600 dark:text-yellow-400',
    confirmBtn: 'bg-yellow-600 hover:bg-yellow-700 text-white',
  },
  default: {
    icon: HelpCircle,
    iconBg: 'bg-blue-100 dark:bg-blue-900/30',
    iconColor: 'text-blue-600 dark:text-blue-400',
    confirmBtn: 'bg-blue-600 hover:bg-blue-700 text-white',
  },
}

export default function ConfirmDialog() {
  const { confirmState, confirmResolve, closeConfirm } = useToast()

  if (!confirmState || !confirmResolve) return null

  const config = typeConfig[confirmState.type || 'default']
  const Icon = config.icon

  const handleConfirm = () => {
    confirmResolve(true)
    closeConfirm()
  }

  const handleCancel = () => {
    confirmResolve(false)
    closeConfirm()
  }

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm animate-fade-in"
        onClick={handleCancel}
      />
      
      {/* Dialog */}
      <div className="relative bg-white dark:bg-gray-800 rounded-[20px] shadow-modal max-w-md w-full animate-scaleIn">
        <div className="p-6">
          <div className="flex items-start gap-4">
            <div className={`p-3 rounded-full ${config.iconBg}`}>
              <Icon className={`w-6 h-6 ${config.iconColor}`} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {confirmState.title}
              </h3>
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                {confirmState.message}
              </p>
            </div>
          </div>
        </div>
        
        <div className="flex justify-end gap-3 px-6 py-4 bg-gray-50 dark:bg-gray-900/50 rounded-b-[20px]">
          <button
            onClick={handleCancel}
            className="h-[44px] px-5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-[12px] hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-200 ease-apple hover:-translate-y-px active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/30"
          >
            {confirmState.cancelText || 'Annulla'}
          </button>
          <button
            onClick={handleConfirm}
            className={`h-[44px] px-5 text-sm font-medium rounded-[12px] transition-all duration-200 ease-apple hover:-translate-y-px active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/30 ${config.confirmBtn}`}
          >
            {confirmState.confirmText || 'Conferma'}
          </button>
        </div>
      </div>
    </div>
  )
}
